import { render, staticRenderFns } from "./sys_account_record.vue?vue&type=template&id=805cd4e2&scoped=true"
import script from "./sys_account_record.vue?vue&type=script&lang=js"
export * from "./sys_account_record.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805cd4e2",
  null
  
)

export default component.exports